<template>
  <div>
    <form
      v-if="step === null"
      :class="[$style.inputForm]"
      @submit.prevent="handleNext"
    >
      <template v-if="!otp_token_required">
        <div>
          <input
            id="user_id"
            v-model="username"
            type="text"
            :class="[$style.formControl]"
            :placeholder="$t('id')"
          />
        </div>
        <div>
          <input
            id="password"
            v-model="password"
            type="password"
            :class="[$style.formControl]"
            :placeholder="$t('password')"
          />
        </div>

        <div
          :class="[$style.formWrap]"
          style="text-align:right;"
          class="form-wrap"
        >
          <p v-if="otp_token_required === false" :class="[$style.findWrap]">
            <router-link
              :to="{ name: 'register' }"
              :class="[$style.loginLink]"
              >{{ $t('cocofx_register') }}</router-link
            >
          </p>
          <div class="f-right">
            <router-link
              :to="{ name: 'account-find', query: { type: 'id' } }"
              >{{ $t('find_id') }}</router-link
            >
            <router-link
              :to="{ name: 'account-find', query: { type: 'password' } }"
              :class="[$style.findLink]"
              >{{ $t('find_password') }}</router-link
            >
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <input
            v-model="otp_token"
            type="text"
            :class="[$style.formControl]"
            placeholder="OTP"
          />
        </div>
      </template>
      <div :class="[$style.btnWrap]">
        <button :class="[$style.loginButton]" @click.prevent="handleNext">
          {{ $t('login') }}
        </button>
      </div>
      <div v-if="otp_token_required" :class="[$style.btnWrap]">
        <button :class="[$style.cancelButton]" @click.prevent="handleCancel">
          {{ $t('back') }}
        </button>
      </div>
      <div v-if="!otp_token_required" :class="[$style.btnWrap]">
        <button :class="[$style.cancelButton]" @click.prevent="handleCancel">{{
          $t('cancel')
        }}</button>
      </div>
      <!-- <p v-else :class="[$style.findWrap]">
          <router-link :to="{ name: 'register' }" :class="[$style.loginLink]">회원가입</router-link>
        </p>-->
    </form>

    <form v-if="step === 'email_verification'" :class="[$style.inputForm]">
      <template v-if="!otp_token_required">
        <div>
          <input
            id="auth_code"
            v-model="auth_code"
            type="text"
            :class="[$style.formControl]"
            :placeholder="$t('verification_code')"
          />
        </div>
      </template>
      <template v-else>
        <div>
          <input
            v-model="otp_token"
            type="text"
            :class="[$style.formControl]"
            placeholder="OTP"
          />
        </div>
      </template>
      <div :class="[$style.btnWrap]">
        <button :class="[$style.loginButton]" @click.prevent="handleCreate">
          {{ $t('check') }}
        </button>
      </div>
      <div v-if="otp_token_required" :class="[$style.btnWrap]">
        <button :class="[$style.cancelButton]" @click.prevent="handleBack">
          {{ $t('back') }}
        </button>
      </div>
      <div v-if="!otp_token_required" :class="[$style.btnWrap]">
        <button :class="[$style.cancelButton]" @click.prevent="handleBack">{{
          $t('cancel')
        }}</button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import { authMethods } from '@state/helpers'
import { createVerification, createVerificationToken } from '@apis/mail'
import { createToken } from '@apis/auth'

export default {
  name: 'EmailVerificationLogin',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      otp_token: '',
      otp_token_required: false,
      step: null,
      auth_code: '',
      token_info: null,
      token: null,
      is_loggedin: false,
    }
  },
  methods: {
    ...authMethods,
    async handleCancel() {
      this.username = ''
      this.password = ''
      this.otp_token = ''
      this.otp_token_required = false
      this.step = null
      await this.localLogout()
      this.$router.push({
        name: 'home',
      })
    },
    async handleBack() {
      this.username = ''
      this.password = ''
      this.otp_token = ''
      this.otp_token_required = false
      this.step = null
      await this.localLogout()
    },
    handleCreateToken() {
      this.loading = true
      createVerificationToken()
        .then(({ token }) => {
          this.token = token
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('toasted_msg.email_auth_send'),
            type: 'success',
          })
          this.token_info = this.$jwt.decode(this.token)
        })
        .catch((err) => this.$toasted.error(err.message))
        .finally(() => {
          this.loading = false
        })
    },
    handleCreate() {
      this.loading = true
      createVerification(this.$data)
        .then(({ token }) => {
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('toasted_msg.email_auth'),
            type: 'success',
          })
          this.$router.push({ name: 'home' })
        })
        .catch((err) => this.$toasted.error(err.message))
        .finally(() => {
          this.loading = false
        })
    },
    async localLogout() {
      delete axios.defaults.headers.common['Authorization']
      await this.$store.dispatch('auth/logOut')
    },
    async localLogin() {
      this.loading = true
      try {
        const { token, otp_token_required } = await createToken(
          this.username,
          this.password,
          this.otp_token
        )
        if (otp_token_required) {
          this.otp_token_required = true
          this.is_loggedin = false
          return
        }
        if (token) {
          this.is_loggedin = true

          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
          await this.$store.dispatch('auth/getUserInfo')
          return
        }
      } catch (err) {
        this.$toasted.error(err.message)
        this.is_loggedin = false
      } finally {
        this.loading = false
      }
    },
    async handleNext() {
      await this.localLogin()

      if (this.is_loggedin) {
        this.step = 'email_verification'
        this.handleCreateToken()
      } else if (!this.is_loggedin) {
        this.step = null
      }
    },
  },
}
</script>
<style lang="scss" module>
@import '@design';

.inputForm {
  position: relative;
  box-sizing: border-box;
  padding: 0 !important;
  padding-top: 10px;
  margin-top: 20px;
}
.formControl {
  margin-bottom: 10px;
}
.formControl:focus {
  border-color: #0068c1;
  outline: rgba(0, 0, 0, 0);
}
.findWrap {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  float: left;
  width: 30%;
  padding: 10px 0;
  font-size: 12px;
  text-align: left;
}
.loginLink {
  font-size: 14px;
  line-height: 22px;
  color: #999;
  cursor: pointer;
}
.btnWrap {
  padding-top: 10px;
}
.loginButton {
  width: 100%;
  padding: 18px;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #0068c1;
  border: none !important;
}
.loginButton:hover {
  color: white !important;
  background-color: #007ae2;
}
.cancelButton {
  width: 100%;
  padding: 18px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  text-align: center;
  cursor: pointer;
  background-color: #eee;
  border: none;
}
.cancelButton:hover {
  background-color: #e5e5e5;
}
.findLink {
  margin-left: 10px;
}

@media (max-width: 1000px) {
  .inputForm {
    padding: 0 20px;
  }
}
</style>
<style scoped>
.f-right {
  display: inline-block;
  float: right;
  width: 70%;
  padding: 10px 0;
  font-size: 14px;
}

@media (max-width: 767px) {
  .f-right {
    width: 100%;
  }
}
</style>
